import "./Assets/css/App.css";
import Dashboard from "./components/Dashboard/Dashboard";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ActivityLogs from "./pages/activitylogs";
import DataCenters from "./pages/datacenters";
import HardwareTest from "./pages/hardwaretest";
import WriteOperations from "./pages/writeoperations";
import ScheduleVisit from "./pages/schedulevisit";
import AuditLog from "./pages/auditlog";
import UpcomingShipments  from "./pages/upcomingshipments";
import Todo from "./pages/todos";
import TicketDetails from "./pages/ticketdetails";
import Profile from "./pages/profile";
import * as API from "./api";
import { useState, React, useEffect } from "react";
import LoadingIcon from "./components/Spinners/Loading";
import { useVerifyUserMutation, useLoginUserMutation, useLazyGetUserQuery  } from "./services/user";
import { getUserDetails } from "./api";
import * as FullStory from '@fullstory/browser';
import { Alert, notification } from "antd";
import RackDetails from "./pages/rackdetails";
import SearchPage from "./pages/searchpage";

function App() {
  const url = new URL(window.location.href);
  const [token, setToken] = useState(url.searchParams.get("token"));
  const id_token = url.searchParams.get("id_token");
  const [allowLogin, setAllowLogin] = useState(null);
  const [spinner, startSpinner] = useState(null);
  const [validateToken, result] = useVerifyUserMutation();
  const [triggerLogin, loginResult] = useLoginUserMutation();
  const [errorMsg, setErrormsg] = useState(false);
  const userDetails = getUserDetails();
  const [triggerLazyGetUser, {data:userLazyData, error: userLazyError, isLoading: isUserLazyLoading, isFetching:isUserLazyFetching}] = useLazyGetUserQuery();
  const [isInfoStored, setIsInfoStored] = useState(false)

  let isImpersonated = localStorage.getItem("isImpersonated") === "true" ? true : false;

  useEffect(() => {
    loadUser();
    FullStory.init({ orgId: 'o-1EMVFS-na1' });
    if(userDetails?.sub) {
      if(!localStorage.getItem("userDetails") || localStorage.getItem("userDetails") === "null"){
        triggerLazyGetUser(userDetails.sub)
        setIsInfoStored(false)
      }
      FullStory.identify(userDetails.extension_ContactID, {
        displayName: userDetails.name,
        email: userDetails.email,
      });
    }
  
    // console.log(`NODE ENV - ${process.env.NODE_ENV}`);
    console.log(`REACT_APP_FT_PORTAL_URL Value - ${process.env.REACT_APP_FT_PORTAL_URL}`);
  }, []);

  useEffect(() => {
    const version = localStorage.getItem('REACT_APP_FTPORTAL_APP_VERSION');
      const versionEnv = process.env.REACT_APP_FTPORTAL_APP_VERSION;
      console.log(`version from storage - ${version}`)
      console.log(`version from env - ${versionEnv}`)
      if (version !== versionEnv) {
        localStorage.setItem('REACT_APP_FTPORTAL_APP_VERSION', process.env.REACT_APP_FTPORTAL_APP_VERSION);
        localStorage.removeItem('ft-portal-col');
      }    
  }, [])

  useEffect(()=>{
    if(!isUserLazyFetching && userLazyData?.data){
      localStorage.setItem("userDetails", userLazyData.data.mobilePhone || null)
      setIsInfoStored(true)
    }
  }, [userLazyData, isUserLazyFetching])

 
  async function callValidateToken(token) {
    if (token) {
      const resp = await validateToken(token).unwrap();
      console.log(`validate token response - ${JSON.stringify(resp)}`);
      if (resp && resp.success) return token;
    }
    return null;
  }

  async function checkInvalidToken(error) {
    if (error.status && error.status === 401 && error?.data?.error_type === "AUTH_FAILURE") return true;
    if(error?.data?.message) {
      notification.error({
        message: 'Authentication Error',
        description: error?.data?.message,
        placement: 'topRight',
      });
    }
    return false;
  }

  async function login() {
    console.log("triggerring login");
    try {
      const resp = await triggerLogin().unwrap();
      if (resp && resp.success && resp.data) {
        const redirectURL = resp.data;
        console.log(`redirect url - ${redirectURL}`);
        window.location.href = redirectURL;
      }
    } catch (error) {
      console.log(`error in login`);
      console.log(error);
      setErrormsg(true);
      return null;
    }
  }

  const loadUser = async () => {
    console.log("logging in");
    let validate;
    if (token) {
      startSpinner(true);
      try {
        validate = await callValidateToken(token);
      } catch (error) {
        console.log("error in validating token");
        console.log(error);
        startSpinner(false);
        if(await checkInvalidToken(error)) {
          API.setMessage("Invalid Request", "error");
          API.clearData();
          setToken(null);
          await login();
        } else {
          console.log("setting error message");
          setErrormsg(true);
          validate = null;
        }
      }
      if (validate) {
        console.log("token is valid");
        API.setToken(token, id_token);
        setToken(token);
        setAllowLogin(true);
        let lastpath = API.getLastPath();
        if (window.location.pathname === "/") {
          API.setLastPath("/");
          console.log(`old A - ${window.location.href}`);
          console.log(`session - ${sessionStorage.getItem("lastPath")}`);
          window.location.href = "/datacenters";
        } else if (
          lastpath !== "/" &&
          lastpath !== null &&
          lastpath !== window.location.href
        ) {
          console.log(`old b - ${lastpath}`);
          window.location.href = lastpath;
        }
        startSpinner(false);
      }
      return;
    }
    console.log(`using old token`);
    const old_token = API.getToken();
    console.log(`old token - ${old_token}`);
    if (!old_token) {
      console.log("no old token found, triggering login");
      startSpinner(false);
      await login();
      return;
    }
    let valid = null;
    try {
      valid = await callValidateToken(old_token);
    } catch (error) {
      console.log("error in validating old token");
      console.log(error);
      startSpinner(false);
      if(old_token && await checkInvalidToken(error)) {
        await login();
        return;
      } else {
        setErrormsg(true);
        valid = null;
      }
    }
    console.log(`validate old token - ${valid}`);
    if (old_token && valid) {
      console.log("old token is valid");
      setToken(old_token);
      setAllowLogin(true);
      let lastpath = API.getLastPath();
      if (window.location.pathname === "/") {
        API.setLastPath("/");
        console.log(`A - ${window.location.href}`);
        console.log(`session - ${sessionStorage.getItem("lastPath")}`);
        window.location.href = "/datacenters";
      } else if (
        lastpath !== "/" &&
        lastpath !== null &&
        lastpath !== window.location.href
      ) {
        console.log(`B - ${lastpath}`);
        // window.location.href = lastpath;
      }
    } else {
      setErrormsg(true);
    }
    return;
  };

  const downTimeMessage = (
    <>
      <b>Scheduled Maintenance Notice: </b>
      Please note that the Field Tech portal will be unavailable between 04:00 EDT / 08:00 UTC to 16:00 EDT / 20:00 UTC on Saturday, June 13th due to a scheduled maintenance that will impact the servers hosting this application. Please reach out to support in case of any queries/concerns.
    </>
  )

  return (
    <div className="wrapper">
      {errorMsg && (
        <Alert 
        message="Network Error"
        description="Please try again later. If the issue persists, please contact dl-ftportal-help@akamai.com"
        type="error"
        showIcon/>
      )}
      {spinner && <LoadingIcon tip="Authenticating..." />}
      {allowLogin && (
        <>
          {/* <Alert message={downTimeMessage} type="warning" showIcon closable /> */}
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard isImpersonated={isImpersonated} />}>
              <Route index path="datacenters" element={<DataCenters isImpersonated={isImpersonated} isInfoStored={isInfoStored}/>}></Route>
              <Route
                path="datacenters/:data_center_id/todos"
                element={<Todo isImpersonated={isImpersonated} type="todos"/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/todos/:ticket_id"
                element={<TicketDetails isImpersonated={isImpersonated} type="todos"/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/rmas/:ticket_id"
                element={<TicketDetails isImpersonated={isImpersonated} type="rmas"/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/rmas"
                element={<Todo isImpersonated={isImpersonated} type="rmas"/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/schedule-visit"
                element={<ScheduleVisit isImpersonated={isImpersonated}/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/audit-log"
                element={<AuditLog isImpersonated={isImpersonated}/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/upcoming-shipments"
                element={<UpcomingShipments isImpersonated={isImpersonated}/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/unknown-racks/"
                element={<RackDetails type='unknown' isImpersonated={isImpersonated}/>}
              ></Route>
              <Route
                path="datacenters/:data_center_id/rack/:rack_number"
                element={<RackDetails type='known' isImpersonated={isImpersonated}/>}
              ></Route>
              <Route
                path="datacenters/search"
                element={<SearchPage isImpersonated={isImpersonated}/>}
              ></Route>
              <Route path="profile" element={<Profile isImpersonated={isImpersonated}/>}></Route>
              <Route path="activitylogs" element={<ActivityLogs isImpersonated={isImpersonated}/>}></Route>
              <Route path="hardwaretest" element={<HardwareTest isImpersonated={isImpersonated}/>}></Route>
              <Route path="writetosiebel" element={<WriteOperations isImpersonated={isImpersonated}/>}></Route>
            </Route>
          </Routes>
        </BrowserRouter>
        </>
        
      )}
    </div>
  );
}

export default App;
